import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "modal__poi-template-wrapper" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.modalData && _ctx.modalData.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal__poi-description",
            innerHTML: _ctx.modalData.description
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ])
  ]))
}